/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Radar_DescInputs */

const en_directory_launch_radar_desc = /** @type {(inputs: Directory_Launch_Radar_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh AI products, ranked by momentum, signals, and launch quality.`)
};

const zh_directory_launch_radar_desc = /** @type {(inputs: Directory_Launch_Radar_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按动量、信号和发布质量排序的新鲜 AI 产品。`)
};

/**
* | output |
* | --- |
* | "Fresh AI products, ranked by momentum, signals, and launch quality." |
*
* @param {Directory_Launch_Radar_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_radar_desc = /** @type {((inputs?: Directory_Launch_Radar_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Radar_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_radar_desc(inputs)
	return zh_directory_launch_radar_desc(inputs)
});
export { directory_launch_radar_desc as "directory.launch.radar_desc" }